export function keepOnlyCurrentLanguage(obj, lang) {
  const result = {};

  for (const key in obj) {
    const value = obj[key];

    // if value is an object AND contains the language key
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      value.hasOwnProperty(lang)
    ) {
      result[key] = { [lang]: value[lang] };
    } else {
      result[key] = value;
    }
  }

  return result;
}

/*export function mergePipeStrings(a, b) {
  return [...new Set(
    [a, b]
      .flatMap(v => Array.isArray(v) ? v : (v ? String(v).split("|") : []))
  )].join("|");
}*/

export function splitPipe(v) {
  return Array.isArray(v) ? v : v ? String(v).split("|") : [];
}

export function mergePipeStrings(a, b) {
  return [...new Set([...splitPipe(a), ...splitPipe(b)])].join("|");
}

export function diffPipeStrings(a, b) {
  const setA = new Set(splitPipe(a));
  return [...new Set(splitPipe(b).filter((v) => !setA.has(v)))].join("|");
}

export function flattenSelectedProperties(
  obj,
  arrayKey,
  objectId,
  matchId,
  propsToInclude = [],
) {
  const result = { ...obj }; // copy all top-level props
  try {
    if (Array.isArray(obj[arrayKey])) {
      const matched = obj[arrayKey].find((item) => item[objectId] === matchId);
      if (matched) {
        // only pick the specified properties
        propsToInclude.forEach((prop) => {
          if (prop in matched) {
            result[prop] = matched[prop];
          }
        });
      }
    }
  } catch (err) {
    console.log(`object`, obj);
    console.log(`object`, obj[arrayKey]);
    console.error(err);
  }

  return result;
}

export const buildOptions = (items, idKey, nameKeys, extraKeys = []) => {
  if (!items?.length) return [];

  return items
    .map((item) => {
      const extraProps = {};

      extraKeys.forEach((key) => {
        extraProps[key] = item[key];
      });

      return {
        id: item[idKey],
        displayName: `${item[idKey]} | ${
          nameKeys.map((k) => item[k]).find(Boolean) || "no display"
        }`,
        ...extraProps,
      };
    })
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
};
